import cx from 'classnames';
import {useCallback, useState} from 'react';
import {useStickerCanvasAdder} from '~/common/FabricInvitation/EventCreateDesign/components/Sticker/components/Stickers/actions/useStickerCanvasAdder';
import {useStickers} from '~/common/FabricInvitation/EventCreateDesign/components/Sticker/components/Stickers/actions/useStickers';
import {useCachedMedia} from '~/common/hooks/useCachedMedia';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {STICKER_UPLOAD_INDEXED_DB_STORE_NAME} from '~/common/indexed-db/dexieStores';
import {StickerUpload} from '../StickerUpload/StickerUpload';
import {StickerList} from './StickerList';
import './Stickers.sass';

export const Stickers = ({flipEnvelope}) => {
  const [showAllStickers, setShowAllStickers] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [activeId, setActiveId] = useState('');

  const {cachedMediaList} = useCachedMedia(STICKER_UPLOAD_INDEXED_DB_STORE_NAME);
  const hasMedia = cachedMediaList?.length > 0;
  const {stickerIcons, customStickerMedias, stickerMediasMapping, customStickerMediasMapping} =
    useStickers();
  const isDesktop = useIsLargishAndUp();
  useStickerCanvasAdder({
    stickerMediasMapping,
    customStickerMediasMapping,
    isCustom,
    setActiveId,
    activeId,
    isDesktop,
  });

  const onClickGenericHandler = useCallback(
    (id, isCustomSticker) => {
      setIsCustom(isCustomSticker);
      flipEnvelope(true);
      setActiveId(id);
    },
    [flipEnvelope]
  );
  const onClickStickerHandler = useCallback(
    (icon, id) => {
      onClickGenericHandler(id, false);
    },
    [onClickGenericHandler]
  );
  const onClickCustomStickerHandler = useCallback(
    (icon, id) => {
      onClickGenericHandler(id, true);
    },
    [onClickGenericHandler]
  );

  const toggleShowAllCustomStickers = useCallback(() => {
    setShowAllStickers((prev) => !prev);
  }, []);

  return (
    <div className={cx('editor-icons', 'editor-icons__sticker')}>
      <div
        className={cx('sticker-upload-container', {
          'sticker-upload-container--filled': hasMedia,
          'sticker-upload-container--show-less': hasMedia && !showAllStickers,
        })}
      >
        <StickerUpload onClickHandler={onClickCustomStickerHandler} />

        <StickerList
          flipEnvelope={flipEnvelope}
          showAll={showAllStickers}
          isCustom
          stickerIcons={customStickerMedias}
          stickerMediasMapping={customStickerMediasMapping}
          toggleShowAll={toggleShowAllCustomStickers}
          onClickHandler={onClickCustomStickerHandler}
        />
      </div>

      <StickerList
        flipEnvelope={flipEnvelope}
        showAll={showAllStickers}
        stickerIcons={stickerIcons}
        stickerMediasMapping={stickerMediasMapping}
        onClickHandler={onClickStickerHandler}
      />
    </div>
  );
};
